const module = {
  namespaced: true,
  state: {
    chatClient: null,
    chatConversation: null,
    chatMessages: [],
    chatNewMessageCount: 0,
    chatUsers: [],
    visioRoom: null,
    visioUsers: []
  },
  mutations: {
    setChatClient(state, v) {
      state.chatClient = v
    },
    setChatConversation(state, v) {
      state.chatConversation = v
    },
    setChatMessages(state, v) {
      state.chatMessages = v
    },
    setChatUsers(state, v) {
      state.chatUsers = v
    },
    setVisioRoom(state, v) {
      state.visioRoom = v
    },
    setVisioUsers(state, v) {
      state.visioUsers = v
    },
    leave(state) {
      console.log("Leave meeting")
      state.chatMessages = []
      state.chatNewMessageCount = 0
      state.chatUsers = []
      state.visioUsers = []

      if (state.visioRoom) {
        if (state.visioRoom?.state !== "disconnected") {
          console.log("Leave visio room")
          state.visioRoom.disconnect()
        }
        state.visioRoom = null
      }
      if (state.chatConversation) {
        console.log("Leave chat conversation")
        state.chatConversation.leave()
        state.chatConversation = null
      }
    }
  }
}

export default module
